import { SEARCH_LIMIT } from '../../../modules/files/file-list.utils.js';

export function updateSearchProgress(percentage) {
	if (typeof window.searchProgress === 'function') window.searchProgress(percentage);
}

// Track previous count to detect changes when on fulltext tab
let previousResultsCount = null;
let forceHighlightNextUpdate = false;

/**
 * Force highlight name search count on next update (used when query/filters change on fulltext tab)
 */
export function forceHighlightNameSearchCount() {
	forceHighlightNextUpdate = true;
}

export function updateResultsCount(count, hasMore = false) {
	const cardRes = $("#nav-names-card-tab .card-results-count");
	if (!cardRes.length) {
		console.warn('[updateResultsCount] Element not found: #nav-names-card-tab .card-results-count');
		return;
	}
	if (count > 0) cardRes.addClass("card-results-found"); else cardRes.removeClass("card-results-found");
	
	const ITEMS_PER_PAGE = 50;
	// Show "+" ВСЕГДА если hasMore === true (есть еще файлы для догрузки)
	// или если count === SEARCH_LIMIT (300) - была обрезка и есть еще результаты
	// КРИТИЧНО: hasMore имеет приоритет - если он true, плюс показывается независимо от count
	const showPlus = hasMore === true || (count === SEARCH_LIMIT);
	const displayCount = showPlus ? `${count}+` : count.toString();
	
	// Логирование для отладки
	console.log('[updateResultsCount]', {
		count,
		hasMore,
		showPlus,
		displayCount,
		SEARCH_LIMIT,
		condition1: hasMore === true,
		condition2: count === SEARCH_LIMIT
	});
	
	const foundTextElement = cardRes.find("div");
	if (foundTextElement.length > 0) {
		const foundText = foundTextElement.html();
		cardRes.html(`<div class="d-inline">${foundText}</div> ${displayCount}`);
	} else {
		cardRes.text(displayCount);
	}
	
	// Highlight name search count when on fulltext tab and results changed
	try {
		const fulltextTab = $('#nav-full-text-card-tab');
		if (fulltextTab.length && fulltextTab.hasClass('active')) {
			// Check if count changed (including hasMore flag change) or if forced highlight
			const currentCountKey = `${count}_${hasMore ? 'more' : 'nomore'}`;
			const previousCountKey = previousResultsCount !== null 
				? `${previousResultsCount.count}_${previousResultsCount.hasMore ? 'more' : 'nomore'}`
				: null;
			
			// Highlight if count changed, forced highlight, or if this is first update after switching to fulltext tab
			if (forceHighlightNextUpdate || previousCountKey !== currentCountKey || previousResultsCount === null) {
				cardRes.addClass('highlight');
				setTimeout(() => {
					cardRes.removeClass('highlight');
				}, 3000);
				forceHighlightNextUpdate = false; // Reset flag after highlighting
			}
		}
		
		// Always update previous count for next comparison
		previousResultsCount = { count, hasMore };
	} catch(_) { /* noop */ }
}

